module.exports = __webpack_public_path__ + "src/assets/img/photo_sil1.d373cc76.jpg";